import MainSection from './MainSection';
export default MainSection;
